export const ActorTypes = ['customer', 'cc-team-member', 'system'] as const
export const EventCategories = ['user', 'subscription', 'animal', 'order', 'discount'] as const

export type EventCategory = (typeof EventCategories)[number]
export type ActorType = (typeof ActorTypes)[number]
